import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { UpdateTimeOffCommand } from './update-time-off.command';

@Injectable({ providedIn: 'root' })
export class UpdateTimeOffUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(command: UpdateTimeOffCommand): Observable<void> {
    return this._repository.updateTimeOff(command.blockId, {
      timeOffTypeId: command.timeOffTypeId,
      startDate: command.startDate,
      endDate: command.endDate,
      notes: command.notes,
      delegations: command.delegations,
    });
  }
}
